import React, { useEffect } from "react";
import { Outlet, useNavigate } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";

import BreadcrumbHistory from "../BreadcrumbHistory";

import MiniDrawer from "../DrawerMenu";
import { useMatches } from "react-router-dom";
import { Box } from "@mui/material";
import { useAppStatus } from "../../hooks/app";
import { useAuth } from "../../hooks/auth";

const Layout = () => {
  const navigate = useNavigate();
  const matches = useMatches();
  const { openDrawer, getCprSummarization, getTicketsSumarization } = useAppStatus();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return navigate('/')
  }, [isAuthenticated, navigate])
  
  useEffect(() => {
    getCprSummarization()
    getTicketsSumarization()
  }, [])
  
  return (
    <Box>
      <MiniDrawer />
      <Box sx={{
        marginLeft: openDrawer ? '300px' : '70px',
        marginTop: '50px',
      }}>
        <main style={{
          position: 'relative',
          flexGrowl: 1,
          padding: '40px',
          backgroundColor: '#FAFAFA',
        }}>
            <TransitionGroup>
              <CSSTransition
                classNames="fade"
                timeout={200}
              >
                <>
                  <BreadcrumbHistory url={matches} />
                  <Outlet />
                </>
              </CSSTransition>
            </TransitionGroup>
          </main>
      </Box>
    </Box>
  );
}

export default Layout;
